import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './Config'; 


if (config.isProduction && !window.__DEV__) {
  // 全面封殺所有 console（連 console.error 都冇）
  const noop = () => {};
  const methods = ['log', 'error', 'warn', 'info', 'debug', 'trace', 'table', 'group', 'groupEnd'];
  methods.forEach(method => {
    console[method] = noop;
  });

  // 額外保險：就算有人用 console.log.bind(console) 都封到
  console.log = noop;
  console.error = noop;
  console.warn = noop;
}

/* ================================================================= */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();